import React, { FC } from 'react';
import styled from 'styled-components';
import {
  OVULATORY_EVENT_APPROXIMATE_RULE_DESCRIPTION,
  OVULATORY_EVENT_NO_RULE_VALUE_LABEL,
} from '../organisms/ovulatory-event-prediction-presentation';

interface OvOvulatoryEventRuleValueProps {
  label: string | null;
  approximate: boolean;
  prefix?: string;
}

const OvOvulatoryEventRuleValue: FC<OvOvulatoryEventRuleValueProps> = ({
  label,
  approximate,
  prefix,
}) => (
  <Wrapper
    title={
      approximate ? OVULATORY_EVENT_APPROXIMATE_RULE_DESCRIPTION : undefined
    }
  >
    {approximate && (
      <>
        <span aria-hidden="true">≈ </span>
        <VisuallyHidden>approximately </VisuallyHidden>
      </>
    )}
    {prefix && `${prefix}: `}
    {label ?? OVULATORY_EVENT_NO_RULE_VALUE_LABEL}
  </Wrapper>
);

export default OvOvulatoryEventRuleValue;

const Wrapper = styled.span`
  display: block;
`;

const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
`;
